import React, { useState } from 'react';
import { EVTypography, EVLink, EVBox } from '@eagleview/ev-comp-library';
import FooterStyles from './FooterStyles';
import useMediaQuery from '../../hooks/useMediaQuery';
import { PRIVACY_POLICY_URL, TERMS_OF_USE_URL } from '../../constants/AppConstants';

function Footer() {
  const classes = FooterStyles();
  const [isExpanded, setIsExpanded] = useState(false);

  const handleToggle = () => {
    setIsExpanded(!isExpanded);
  };
  const isNarrow = useMediaQuery(675);
  return (
    <footer className={classes.footer}>
      <EVTypography className={classes.footerLinksContainer}>
        <EVLink target="_blank" href={TERMS_OF_USE_URL}>Terms of Use</EVLink>
        {' | '}
        <EVLink target="_blank" href={PRIVACY_POLICY_URL}>Privacy Policy</EVLink>
      </EVTypography>
      <EVBox className={classes.section}>
        <EVBox className={classes.content} style={{ maxHeight: isExpanded ? 'none' : !isNarrow ? 'none' : '13px' }}>
          <EVTypography className={classes.text}>
            © 2025 Eagleview Technologies, Inc. and Pictometry International Corp. All rights reserved. Reports issued by Eagleview Technologies
            {' '}
            are covered by one or more international and U.S. patents and pending applications, including U.S. Patent Nos. 8,078,436;
            {' '}
            8,145,578; 8,170,840; 8,209,152; 8,515,125; 8,825,454; 9,135,737; 8,670,961; 9,514,568; 8,818,770; 8,542,880; 9,244,589;
            {' '}
            9,329,749; 8,938,090 and 9,183,538. Other patents pending.
          </EVTypography>
        </EVBox>
        <EVBox style={{ cursor: 'pointer' }} onClick={handleToggle}>
          <EVTypography style={{ display: isNarrow && isExpanded ? 'block' : 'none' }}>&#8722;</EVTypography>
          <EVTypography style={{ display: isNarrow && !isExpanded ? 'block' : 'none' }}>&#43;</EVTypography>
        </EVBox>
      </EVBox>
    </footer>
  );
}

export default Footer;
